import React from 'react';
import PropTypes from 'prop-types';

const CircleArrowButton = ({ className, onClick, direction }) => (
  <button
    className={`circle-arrow-button circle-arrow-button--${direction} ${className}`}
    onClick={onClick}
  >
  </button>
);

CircleArrowButton.defaultProps = {
  onClick: () => {},
  direction: 'left'
};

CircleArrowButton.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default CircleArrowButton;
